import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { EngineeringService } from 'src/app/services/engineering/engineering.service';

@Component({
  selector: 'app-submitteddrawings',
  templateUrl: './submitteddrawings.component.html',
  styleUrls: ['./submitteddrawings.component.css']
})
export class SubmitteddrawingsComponent implements OnInit {

  data: any;

  constructor(private engineeringServices : EngineeringService, private router : Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.getSubmittedDrawingsVendor();
  }

  getSubmittedDrawingsVendor() {
    this.engineeringServices.GetSubmittedDrawingsVendor().subscribe(
      data => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  submitResponse = function (id) {
    //alert(id);
    this.router.navigate(['/drawingcomments/' + id + '']);
  }
  smtdrawingvendorsearch(keyword){
    this.engineeringServices.SmtDrawingVendorSearch(keyword).subscribe(
      (data)=>{
        this.data=data;
        console.log(data);
      }
    )
  }

}
